import React from 'react'
import { get } from 'lodash'
import T from 'prop-types'
import Button from 'components/Button'
import Joi from 'joi'

import Step from '../../components/Step'
import getGenderText from '../../helpers/getGenderText'

const WHY = [
  ['symptoms', 'Har symptomer'],
  ['infected_contact', 'Har vært i kontakt med en smittet'],
  ['travel_abroad', 'Har vært i utlandet'],
]

export const validator = (values, user_id) => Joi.object({
  details: Joi.object({
    test_indication: Joi.object({
      symptoms: Joi.boolean(),
      infected_contact: Joi.boolean(),
      travel_abroad: Joi.boolean(),
    }).required(),
  }).unknown(true).required(),
}).unknown(true)

export default function Why({ changeStep, values, onChange }) {
  const handleChange = (value) => () => {
    const currentValue = get(values, `details.test_indication.${value}`, false)
    const newValue = !currentValue

    onChange(`details.test_indication.${value}`, newValue || undefined)
  }

  const setNone = () => onChange('details.test_indication', {})

  const noTestIndications =
    typeof get(values, 'details.test_indication') === 'object' &&
    Object.keys(get(values, 'details.test_indication') || {}).length === 0

  const onBehalfOfFirstName = get(values, 'details.on_behalf_of.first_name')

  const title = getGenderText('Hvorfor vil %s teste deg?', values)

  return (
    <Step
      title={title}
      onSubmit={changeStep}
      submit="Gå videre"
      submitDisabled={!get(values, 'details.test_indication')}
      info={
        onBehalfOfFirstName
          ? `Marker det som gjelder ${onBehalfOfFirstName} (flere valg mulig)`
          : 'Marker det som gjelder deg (flere valg mulig)'
      }
    >
      {WHY.map(([value, label]) => (
        <Button
          key={value}
          inline
          small
          onClick={handleChange(value)}
          selected={get(values, `details.test_indication.${value}`, false)}
        >
          {label}
        </Button>
      ))}
      <Button inline small onClick={setNone} selected={noTestIndications}>
        Ingen av delene
      </Button>
    </Step>
  )
}

Why.propTypes = {
  changeStep: T.func.isRequired,
  values: T.object.isRequired,
  onChange: T.func.isRequired,
}
